"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _theme = require("./theme");

var _dropdown = require("./dropdown");

var _button = require("./button");

var _layout = require("./layout");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n      border-radius: 0 0 ", "\n        ", ";\n\n      border-right: 1px solid ", ";\n\n      border-left: 1px solid ", ";\n\n      border-bottom: 1px solid ", ";\n\n      border-color: ", ";\n    "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  padding: ", ";\n  display: none;\n  background: ", ";\n\n  ", "\n\n  &.flexi-tab-content-active {\n    display: block;\n  }\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n        border: none;\n        border-right: 1px solid ", ";\n        border-radius: 0;\n        background-color: none;\n        &:last-child{\n          border-right: none;\n        }\n        &.flexi-tab-label-active {\n            background-color: ", ";\n            border-bottom: none;\n            color: ", ";\n            &:after{\n              display: none;\n            }\n        }\n      "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n            background: ", ";\n          "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n          border-color: ", ";\n        "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n            background-color: none;\n            border: 1px solid ", ";\n          "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n        border: 1px solid ", ";\n        border-radius: ", "\n          ", " 0 0;\n        background-color: ", ";\n          ", "\n      "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n        width: -webkit-fill-available;\n      "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n          width: 100%;\n          justify-content: stretch;\n        "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n        border: 1px solid ", ";\n        display: inline-flex;\n        margin-bottom: 20px;\n        ", "\n        overflow: hidden;\n        border-radius:", ";\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      border-bottom: 1px solid\n        ", ";\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    @media (max-width: ", "){\n      display: none;\n    }\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: 1px solid ", ";\n  min-height: 40px;\n  margin: 0;\n  font-size: ", ";\n  display: flex;\n  ", "\n  \n\n  ", "\n\n  ", "\n\n  & .flexi-tab-header-box {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0 10px;\n    min-height: 40px;\n    position: relative;\n    cursor: pointer;\n    color: ", ";\n\n    ", "\n\n    ", "\n    \n      \n\n\n    & .flexi-tab-icon-right {\n      padding-left: 10px;\n    }\n\n    & .flexi-tab-icon-left {\n      padding-right: 10px;\n    }\n\n    &.disabled {\n      opacity: 0.3;\n    }\n\n    &.flexi-tab-label-active {\n      background: ", ";\n\n      ", "\n\n      &::after {\n        height: 3px;\n        background: ", ";\n        content: '';\n        position: absolute;\n        bottom: -2px;\n        width: 100%;\n        display: block;\n\n        ", "\n      }\n    }\n\n    ", "\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n        & .flexi-tab-label-active {\n          border-radius: ", " 0 0 ", ";\n            border-right: 1px solid ", ";\n            background-color: ", ";\n            border-bottom: none;\n            color: ", ";\n            &:after{\n              display: none;\n            }\n        }\n      "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n            background: ", ";\n          "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n          border-color: ", ";\n           border-radius: ", " 0 0 0;\n           border-right: 1px solid ", ";\n\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        border: 1px solid ", ";\n        margin-bottom: 20px;\n        padding-right: 6px;\n        border-radius:", ";\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n            background-color: none;\n            border: 1px solid ", ";\n          "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        border: 1px solid ", ";\n        padding-right: 6px;\n        border-radius: ", "\n          ", " 0 0;\n        /* overflow: hidden; */\n        background-color: ", ";\n          ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  @media (max-width: ", "){\n    display: grid;\n  }\n  min-height: 48px;\n  grid-template-columns:auto max-content;\n  align-items: center;\n  border-bottom: 1px solid ", ";\n\n\n  & .flexi-tab-header-box {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0 10px;\n    min-height: 48px;\n    position: relative;\n    cursor: pointer;\n    color: ", ";\n  }\n\n  ", "\n\n  ", "\n\n  & .flexi-tab-icon-right {\n      padding-left: 10px;\n    }\n\n    & .flexi-tab-icon-left {\n      padding-right: 10px;\n    }\n\n    &.disabled {\n      opacity: 0.3;\n    }\n\n    & .flexi-tab-label-active {\n      background: ", ";\n\n      ", "\n\n      &::after {\n        height: 3px;\n        background: ", ";\n        content: '';\n        position: absolute;\n        bottom: -2px;\n        width: 100%;\n        display: block;\n\n        ", "\n      }\n    }\n\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TabMobileHeader = (0, _styledComponents["default"])('div').attrs({
  className: 'flexi-tab-header-mobile'
})(_templateObject(), function (props) {
  return props.breakpoint;
}, function (props) {
  return props.color;
}, function (props) {
  return props.labelColor;
}, function (props) {
  return props.mode === 'card' && (0, _styledComponents.css)(_templateObject2(), function (props) {
    return props.color;
  }, function (props) {
    return props.theme.SecondaryRadius;
  }, function (props) {
    return props.theme.SecondaryRadius;
  }, function (props) {
    return props.bgColor ? "darken(0.25, props.bgColor)" : props.color;
  }, function (props) {
    return props.lined && (0, _styledComponents.css)(_templateObject3(), function (props) {
      return props.color;
    });
  });
}, function (props) {
  return props.mode === 'segmented' && (0, _styledComponents.css)(_templateObject4(), function (props) {
    return props.color;
  }, function (props) {
    return props.theme.SecondaryRadius;
  });
}, function (props) {
  return props.bgColor ? props.bgColor : '#fff';
}, function (props) {
  return props.mode === 'card' && (0, _styledComponents.css)(_templateObject5(), function (props) {
    return props.highlightColor ? props.highlightColor : props.color;
  }, function (props) {
    return props.theme.SecondaryRadius;
  }, function (props) {
    return props.color;
  });
}, function (props) {
  return props.highlightColor ? props.highlightColor : props.theme.PrimaryColor;
}, function (props) {
  return props.mode === 'card' && (0, _styledComponents.css)(_templateObject6(), function (props) {
    return props.bgColor;
  });
}, function (props) {
  return props.mode === 'segmented' && (0, _styledComponents.css)(_templateObject7(), function (props) {
    return props.theme.SecondaryRadius;
  }, function (props) {
    return props.theme.SecondaryRadius;
  }, function (props) {
    return props.color;
  }, function (props) {
    return props.highlightColor;
  }, function (props) {
    return (0, _polished.readableColor)(props.highlightColor ? props.highlightColor : "#fff", '#222', '#fff', true);
  });
});
var TabHeader = (0, _styledComponents["default"])('div').attrs({
  className: 'flexi-tab-header'
})(_templateObject8(), function (props) {
  return props.color;
}, function (props) {
  return props.theme.PrimaryFontSize;
}, function (props) {
  return props.responsive && (0, _styledComponents.css)(_templateObject9(), function (props) {
    return props.breakpoint;
  });
}, function (props) {
  return props.mode === 'card' && (0, _styledComponents.css)(_templateObject10(), function (props) {
    return props.highlightColor ? props.highlightColor : props.color;
  });
}, function (props) {
  return props.mode === 'segmented' && (0, _styledComponents.css)(_templateObject11(), function (props) {
    return props.color;
  }, function (props) {
    return props.justifyTabs && (0, _styledComponents.css)(_templateObject12());
  }, function (props) {
    return props.theme.SecondaryRadius;
  });
}, function (props) {
  return props.labelColor;
}, function (props) {
  return props.justifyTabs && (0, _styledComponents.css)(_templateObject13());
}, function (props) {
  return props.mode === 'card' && (0, _styledComponents.css)(_templateObject14(), function (props) {
    return props.color;
  }, function (props) {
    return props.theme.SecondaryRadius;
  }, function (props) {
    return props.theme.SecondaryRadius;
  }, function (props) {
    return props.bgColor ? "darken(0.25, props.bgColor)" : props.color;
  }, function (props) {
    return props.lined && (0, _styledComponents.css)(_templateObject15(), function (props) {
      return props.color;
    });
  });
}, function (props) {
  return props.bgColor ? props.bgColor : '#fff';
}, function (props) {
  return props.mode === 'card' && (0, _styledComponents.css)(_templateObject16(), function (props) {
    return props.highlightColor ? props.highlightColor : props.color;
  });
}, function (props) {
  return props.highlightColor ? props.highlightColor : props.theme.PrimaryColor;
}, function (props) {
  return props.mode === 'card' && (0, _styledComponents.css)(_templateObject17(), function (props) {
    return props.bgColor;
  });
}, function (props) {
  return props.mode === 'segmented' && (0, _styledComponents.css)(_templateObject18(), function (props) {
    return props.color;
  }, function (props) {
    return props.highlightColor;
  }, function (props) {
    return (0, _polished.readableColor)(props.highlightColor ? props.highlightColor : "#fff", '#222', '#fff', true);
  });
});

var TabContent = _styledComponents["default"].div(_templateObject19(), function (props) {
  return props.padContent;
}, function (props) {
  return props.bgColor ? props.bgColor : 'transparent';
}, function (props) {
  return props.mode === 'card' && (0, _styledComponents.css)(_templateObject20(), function (props) {
    return props.theme.SecondaryRadius;
  }, function (props) {
    return props.theme.SecondaryRadius;
  }, function (props) {
    return props.color;
  }, function (props) {
    return props.color;
  }, function (props) {
    return props.color;
  }, function (props) {
    return props.highlightColor ? props.highlightColor : props.color;
  });
});

var Tabs = function Tabs(props) {
  var _myChildren$active, _myChildren$active$pr, _myChildren$active2, _myChildren$active2$p, _myChildren$active3, _myChildren$active3$p;

  var _useState = (0, _react.useState)(props.activeTab),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var setActiveTab = function setActiveTab(id) {
    setActive(id);
  };

  var mode = props.mode,
      justifyTabs = props.justifyTabs,
      bgColor = props.bgColor,
      padContent = props.padContent,
      labelColor = props.labelColor,
      highlightColor = props.highlightColor,
      color = props.color,
      responsive = props.responsive,
      breakpoint = props.breakpoint;
  var myChildren = [];

  if (props.children) {
    myChildren = !Array.isArray(props.children) ? [props.children] : props.children;
  }

  myChildren = myChildren.filter(function (e) {
    return e;
  });

  if (myChildren.length < 1) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(TabHeader, {
    mode: mode,
    justifyTabs: justifyTabs,
    bgColor: bgColor,
    labelColor: labelColor,
    highlightColor: highlightColor,
    color: color,
    breakpoint: breakpoint,
    responsive: responsive
  }, myChildren.map(function (elem, id) {
    var _elem$props = elem.props,
        label = _elem$props.label,
        disabled = _elem$props.disabled,
        iconRight = _elem$props.iconRight,
        iconLeft = _elem$props.iconLeft,
        tabClick = _elem$props.tabClick;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: id,
      className: "flexi-tab-header-box ".concat(id === active ? 'flexi-tab-label-active' : 'flexi-tab-inactive', " ").concat(disabled ? 'disabled' : ''),
      onClick: function onClick(e) {
        if (!disabled) {
          setActiveTab(id);
          tabClick && tabClick();
        }
      }
    }, iconRight ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "flexi-tab-icon-left"
    }, iconRight) : null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "flexi-tab-label"
    }, label), iconLeft ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "flexi-tab-icon-right"
    }, iconLeft) : null);
  })), props.responsive && /*#__PURE__*/_react["default"].createElement(TabMobileHeader, {
    mode: mode,
    justifyTabs: justifyTabs,
    bgColor: bgColor,
    labelColor: labelColor,
    highlightColor: highlightColor,
    color: color,
    breakpoint: breakpoint,
    responsive: responsive
  }, /*#__PURE__*/_react["default"].createElement(_layout.Box, null, /*#__PURE__*/_react["default"].createElement("div", {
    key: active,
    className: "flexi-tab-header-box flexi-tab-label-active"
  }, ((_myChildren$active = myChildren[active]) === null || _myChildren$active === void 0 ? void 0 : (_myChildren$active$pr = _myChildren$active.props) === null || _myChildren$active$pr === void 0 ? void 0 : _myChildren$active$pr.iconRight) ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "flexi-tab-icon-left"
  }, myChildren[active].props.iconRight) : null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flexi-tab-label"
  }, (_myChildren$active2 = myChildren[active]) === null || _myChildren$active2 === void 0 ? void 0 : (_myChildren$active2$p = _myChildren$active2.props) === null || _myChildren$active2$p === void 0 ? void 0 : _myChildren$active2$p.label), ((_myChildren$active3 = myChildren[active]) === null || _myChildren$active3 === void 0 ? void 0 : (_myChildren$active3$p = _myChildren$active3.props) === null || _myChildren$active3$p === void 0 ? void 0 : _myChildren$active3$p.iconLeft) ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "flexi-tab-icon-right"
  }, myChildren[active].props.iconLeft) : null)), myChildren.length > 1 && /*#__PURE__*/_react["default"].createElement(_dropdown.DropDown, {
    label: /*#__PURE__*/_react["default"].createElement(_button.Button, _extends({
      pad: "0 10px"
    }, props.tabDropDown, {
      height: 30,
      icon: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.menuLabel, " ", /*#__PURE__*/_react["default"].createElement("i", {
        className: "flexibull-angle-down"
      }))
    })),
    menuAlign: "bottom right",
    trigger: "click",
    menuList: myChildren.map(function (elem, idx) {
      var _elem$props$iconLeft, _elem$props$iconRight;

      return _objectSpread(_objectSpread({}, elem === null || elem === void 0 ? void 0 : elem.props), {}, {
        onClick: (elem === null || elem === void 0 ? void 0 : elem.props.disabled) || idx === active ? function () {} : function () {
          return setActiveTab(idx);
        },
        disable: (elem === null || elem === void 0 ? void 0 : elem.props.disabled) || idx === active,
        iconLeft: elem === null || elem === void 0 ? void 0 : (_elem$props$iconLeft = elem.props.iconLeft) === null || _elem$props$iconLeft === void 0 ? void 0 : _elem$props$iconLeft.props.className,
        iconRight: elem === null || elem === void 0 ? void 0 : (_elem$props$iconRight = elem.props.iconRight) === null || _elem$props$iconRight === void 0 ? void 0 : _elem$props$iconRight.props.className
      });
    })
  })), myChildren.map(function (elem, id) {
    var _elem$props2 = elem.props,
        children = _elem$props2.children,
        disabled = _elem$props2.disabled;
    var persist = elem.props.persist ? elem.props.persist : true;

    if ((persist || id === active) && !disabled) {
      return /*#__PURE__*/_react["default"].createElement(TabContent, {
        key: id,
        className: id === active ? 'flexi-tab-content-active' : 'flexi-tab-content-inactive',
        bgColor: bgColor,
        padContent: padContent,
        mode: mode,
        highlightColor: highlightColor,
        color: color
      }, children);
    }
  }));
};

exports.Tabs = Tabs;
Tabs.defaultProps = {
  activeTab: 0,
  persist: true,
  mode: 'transparent',
  justifyTabs: false,
  bgColor: '#fff',
  padContent: '10px',
  color: _theme.FlexTheme.PrimaryBorderColor,
  responsive: true,
  breakpoint: "800px",
  menuLabel: "More Options",
  tabDropDown: {}
};
Tabs.propTypes = {
  activeTab: _propTypes["default"].number,
  persist: _propTypes["default"].bool,
  mode: _propTypes["default"].string,
  justifyTabs: _propTypes["default"].bool,
  bgColor: _propTypes["default"].string,
  labelColor: _propTypes["default"].string,
  highlightColor: _propTypes["default"].string,
  padContent: _propTypes["default"].string,
  iconRight: _propTypes["default"].node,
  iconLeft: _propTypes["default"].node,
  responsive: _propTypes["default"].bool,
  breakpoint: _propTypes["default"].string,
  menuLabel: _propTypes["default"].string,
  tabDropDown: _propTypes["default"].Array
};